import { useReducer } from "react";
import { toast } from "react-toastify";
import { firestore, storage, timestamp } from "../../firebase/utiles";
import PlatoContext from "./PlatoContext";
import PlatoReducer from "./PlatoReducer";
import {
  OBTENER_PLATOS,
  ALMACENANDO_PLATO,
  PREPARANDO_PLATO,
  LIMPIAR_ESTADO_PLATOS,
  SELECCIONAR_PLATO,
  DESELECCIONAR_PLATO,
} from "../types";

const PlatoState = ({ children }) => {
  const initialState = {
    platos: [],
    plato: null,
    guardando: false,
  };

  const [state, dispatch] = useReducer(PlatoReducer, initialState);

  // agregar nuevo plato
  const agregarPlato = (data) => {
    const creado = timestamp();
    const usuario = data.usuarioNombre;
    const usuarioId = data.usuarioId;
    const nombre = data.nombre;
    const descripcion = data.descripcion;
    const precio = Number(data.precio);
    const imagenUrl = data.imagenUrl;

    firestore.collection("platos").add({
      creado,
      usuario,
      usuarioId,
      nombre,
      descripcion,
      precio,
      imagenUrl,
    });
    dispatch({
      type: ALMACENANDO_PLATO,
    });
    toast.success("Plato almacenado con exito");
  };

  // eliminar plato
  const eliminarPlato = (data) => {
    firestore.collection("platos").doc(data.id).delete();
    storage.refFromURL(data.imagenUrl).delete();
    toast.success("Plato eliminado con exito");
  };

  // obtener todo los platos
  const obtenerPlatos = () => {
    firestore.collection("platos").onSnapshot((snap) => {
      const docs = [];
      snap.forEach((doc) => {
        docs.push({
          ...doc.data(),
          id: doc.id,
        });
      });
      dispatch({
        type: OBTENER_PLATOS,
        payload: docs,
      });
    });
  };

  // limpiar el estado
  const limpiarEstado = () => {
    dispatch({
      type: LIMPIAR_ESTADO_PLATOS,
    });
  };

  // seleccionar plato
  const seleccionarPlato = (id) => {
    firestore
      .collection("platos")
      .doc(id)
      .get()
      .then((doc) => {
        if (doc.exists) {
          const docData = {
            ...doc.data(),
            id: doc.id,
          };
          dispatch({
            type: SELECCIONAR_PLATO,
            payload: docData,
          });
        }
      });
  };

  // deseleccionar plato
  const deseleccionarPlato = () => {
    dispatch({
      type: DESELECCIONAR_PLATO,
    });
  };

  // prepararse para guardar o actualizar de nuevo
  const prepararPlato = () => {
    dispatch({
      type: PREPARANDO_PLATO,
    });
  };

  return (
    <PlatoContext.Provider
      value={{
        platos: state.platos,
        plato: state.plato,
        guardando: state.guardando,
        obtenerPlatos,
        limpiarEstado,
        agregarPlato,
        eliminarPlato,
        seleccionarPlato,
        deseleccionarPlato,
        prepararPlato,
      }}
    >
      {children}
    </PlatoContext.Provider>
  );
};

export default PlatoState;
